import React, { useState, useEffect, useRef, forwardRef } from "react"
import { Sprite, Text, useTick, Container } from "@inlet/react-pixi"
import { TextStyle } from "pixi.js"
import ActiveHighlighter from "components/active-highlighter"
import Blur from "components/blur"
import { clamp, lerp } from "utils/math"
import { icons, blurredIcons } from "global.js"

const textStyle = new TextStyle({
  align: "center",
  fontFamily: "monospace",
  fontSize: 12,
  fontWeight: 400,
  fill: ["#ffffff", "#e295cd"], // gradient
  stroke: "#000000",
  strokeThickness: 1,
  letterSpacing: 0,
  dropShadow: false,
  dropShadowColor: "#ccced2",
  dropShadowBlur: 4,
  dropShadowAngle: Math.PI / 6,
  dropShadowDistance: 6,
  wordWrap: true,
  wordWrapWidth: 60,
})

const Symbol = ({ item }) => (
  <Sprite width={60} height={60} image={icons[item]} />
)

const BlurredSymbol = ({ item }) => (
  <Sprite width={60} height={60} image={icons[item]} />
)

const Squash = ({ item, counter, columnIndex }) => {
  const time = useRef(0)
  const ref = useRef()
  useTick((delta, x) => {
    time.current += x.elapsedMS
    const t = clamp(time.current / 1300)
    ref.current.scale.y = lerp(0.33, 0.16, 1 - 2 * (t - 0.5))
    ref.current.y = lerp(0, 30, 1 - 2 * (t - 0.5))
  })
  return <Sprite ref={ref} width={60} height={60} image={icons[item]} />
}

const animations = {
  active: () => <></>,
  squash: Squash,
  blur: BlurredSymbol,
}

const ReelItem = forwardRef(function ReelItem(
  { animation, time, item, counter, i, ...props },
  ref
) {
  const Component = animations[animation] || Symbol
  //useEffect(() => {
  //  setComponent(animations[animationRef.current] || Symbol)
  //}, [animationRef.current])
  return (
    <Container {...props} ref={ref}>
      <Container scale={{ x: 1.05, y: 1.05 }}>
        <Container x={-1.5} y={-1.5}>
          <Component time={time} item={item} />
        </Container>
      </Container>
      {/*typeof i === "number" && (
        <Text text={`${i}`} anchor={0.5} x={10} y={10} style={textStyle} />
      )*/}
    </Container>
  )
})

export default ReelItem
